import Vue from 'vue'
import App from './App.vue'
import 'reset-css'
import ElementUI from 'element-ui'
import '@/assets/iconfont/iconfont.css'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/app.less'
import './assets/css/list.less'
import './assets/css/edit.less'
import router from './router'
import store from './store'
import echarts from 'echarts'
import axios from 'axios'
import mixin from './mixin'
import Breadcrumb from '@/components/Breadcrumb'
Vue.prototype.$echarts = echarts
Vue.prototype.$axios = axios
Vue.component('breadcrumb', Breadcrumb)
Vue.mixin(mixin)
Vue.use(ElementUI)
Vue.config.productionTip = false

Vue.directive('auth', (el, binding) => {
  const path = router.currentRoute.path
  const arg = binding.arg
  const btns = store.state.permissions.find(p => p.moduleUrl === path)?.buttonList
  el.style.display = btns && btns.includes(arg) ? 'block' : 'none'
})

const vue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
export default vue